export default __webpack_public_path__ + "static/media/emenu-logo.231bd4e3.svg";